'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "onOpenChange", "options", "resolver", "value", "uiFormControlProps", "multi"];
import { List } from 'immutable';
import { useCallback, useMemo } from 'react';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { getTransferableProps } from './filterInputProps';
import PropTypes from 'prop-types';
import ReferenceResolverLiteType from 'reference-resolvers-lite/components/proptypes/ReferenceResolverLiteType';
import { listOf, recordOf } from 'react-immutable-proptypes';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';

// This component serves as an interface to reference resolvers lite. THe select
// component it provides only supports arrays so we have to check if the options
// in the operator are an Immutable List and if they are convert them to/from a
// JS array.
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorExternalOptionInput = props => {
  const {
      onChange,
      onOpenChange,
      options,
      resolver,
      value,
      uiFormControlProps,
      multi
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const safeOnChange = useCallback(event => {
    const newValue = multi ? List(event.target.value) : event.target.value;
    onChange(SyntheticEvent(newValue));
  }, [onChange, multi]);
  const jsOptions = useMemo(() => options.toArray().map(({
    label,
    value: optionValue
  }) => ({
    text: label,
    value: optionValue
  })), [options]);
  const jsValue = useMemo(() => {
    if (value) {
      if (typeof value.toArray === 'function') {
        return value.toArray();
      }
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === 'string') {
        if (multi) {
          return [value];
        }
        return value;
      }
    }
    return multi ? [] : undefined;
  }, [value, multi]);
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder,
    className,
    disabled,
    onKeyDown,
    onKeyPress,
    onKeyUp,
    readOnly
  } = transferableProps;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": uiFormControlProps['aria-label'],
    error: uiFormControlProps.error,
    validationMessage: uiFormControlProps.validationMessage,
    children: /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, {
      className: className,
      "data-selenium-test": dataSeleniumTest,
      disabled: disabled,
      multi: multi,
      onChange: safeOnChange,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: onKeyUp,
      onOpenChange: onOpenChange,
      options: jsOptions,
      placeholder: placeholder,
      readOnly: readOnly,
      resolver: resolver,
      value: jsValue
    })
  });
};
FilterOperatorExternalOptionInput.propTypes = {
  multi: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func,
  options: listOf(recordOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  resolver: ReferenceResolverLiteType.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  uiFormControlProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, listOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
};
export default FilterOperatorExternalOptionInput;